import React from 'react';
import { Input, SearchIcon } from '@avila-tek/ui/src';

interface SearchInputProps {
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  action?: () => void;
  className?: string;
  placeholder?: string;
  label?: string;
}

function SearchInput({
  searchText,
  setSearchText,
  action,
  className,
  placeholder,
  label,
}: SearchInputProps) {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  return (
    <Input
      placeholder={placeholder ?? 'Buscar'}
      className={` ${className}`}
      value={searchText}
      onChange={onChange}
      label={label}
      rightIcon={
        <SearchIcon
          className={`w-5 h-5 text-neutral-500 cursor-pointer `}
          onClick={(e) => {
            e.preventDefault();
            action();
          }}
        />
      }
    />
  );
}

export default SearchInput;
